export default function passesDateRangeFilter(item, filter) {
    // IF the active filter does not have value then we pass the check without question
    // For Date range filters, the first value is From and the 2nd value is To
    if (!filter.values.length || (!filter.values[0] && !filter.values[1])) { return true; }

    // From check
    if (filter.values[0]) {
        if (item.timestamp < filter.values[0]) {
            return false;
        }
    }

    // To check
    if (filter.values[1]) {
        // Add 1 day to the "To" value as its selection is done a clock 00 of the day
        const toValue = parseInt(filter.values[1], 10) + (24 * 60 * 60 * 1000);
        if (item.timestamp > (toValue - 1)) {
            return false;
        }
    }

    // All passed
    return true;
}
